import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import './VenuesSection.css';

export default function VenuesSection() {
  const { data: escenariosData, isFetching: loading } = useQuery({
    queryKey: ['venues'],
    queryFn: async () => {
      const res = await fetch('/api/escenarios').then(r => r.json());
      if (!res.exito) throw new Error('Failed to load venues');
      return res.datos;
    },
    staleTime: 5 * 60 * 1000,
  });

  const escenarios = escenariosData || [];

  if (loading) {
    return (
      <section className="seccion-escenarios">
        <div className="seccion-escenarios__header">
          <h2 className="titulo-seccion">Escenarios Icónicos</h2>
          <p className="subtitulo-seccion">Los lugares donde la historia se escribe nota a nota.</p>
        </div>
        <div className="seccion-escenarios__loading">Cargando escenarios...</div>
      </section>
    );
  }

  if (escenarios.length === 0) return null;

  return (
    <section className="seccion-escenarios">
      <div className="seccion-escenarios__header">
        <h2 className="titulo-seccion">Escenarios Icónicos</h2>
        <p className="subtitulo-seccion">
          Los lugares donde la historia se escribe nota a nota.
        </p>
      </div>
      <div className="seccion-escenarios__grid">
        {escenarios.map(v => (
          <Link to={`/eventos?venue_id=${v.id}`} className="tarjeta-escenario" key={v.id}>
            <div className="tarjeta-escenario__image-wrap">
              <img
                className="tarjeta-escenario__image"
                src={v.image_url || 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80'}
                alt={v.name}
                width="400"
                height="300"
                loading="lazy"
              />
            </div>
            <div className="tarjeta-escenario__gradient" />
            <div className="tarjeta-escenario__info">
              <h4 className="tarjeta-escenario__name">{v.name}</h4>
              <p className="tarjeta-escenario__detail">
                {v.capacity ? `${Number(v.capacity).toLocaleString('es-CO')} Capacidad` : ''}
                {v.capacity && v.city ? ' • ' : ''}
                {v.city || ''}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
